import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../types'
import * as api from '../../api'

function* getLeadSchemeList() {
  yield put({ type: types.LEAD_SET_FETCHING_LEAD_SCHEME_LIST })
  const { ok, data } = yield call(api.getLeadSchemeList)
  if (ok)
    yield put({ type: types.LEAD_SET_LEAD_SCHEME_LIST, data })
  else
    yield put({ type: types.LEAD_SET_FETCHING_LEAD_SCHEME_LIST, isFetching: false })
}

export function* leadSaga() {
  yield takeLatest(types.LEAD_ACTION_GET_LEAD_SCHEME_LIST, getLeadSchemeList)
}
